import React from 'react';
import { RegisterForm } from './RegisterForm';
import { Link } from 'react-router-dom';

const Register = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1F0A0F] py-12 px-4 sm:px-6 lg:px-8">
      <div className="relative max-w-md w-full">
        {/* Texture overlay */}
        <div className="absolute inset-0 bg-texture-light opacity-[0.02] rounded-xl"></div>
        
        <div className="relative bg-parchment-50 p-8 rounded-xl border border-gold-200/30 shadow-xl">
          <div className="absolute inset-0 bg-gradient-to-b from-burgundy-50/10 to-transparent rounded-xl"></div>
          
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold-400/20 rounded-tl-xl"></div>
          <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-gold-400/20 rounded-tr-xl"></div>
          <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-gold-400/20 rounded-bl-xl"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold-400/20 rounded-br-xl"></div>
          
          <div className="relative space-y-8">
            <div className="text-center">
              <h2 className="text-4xl font-ornate text-burgundy-800">
                Create Account
              </h2>
              <div className="mt-4 flex items-center justify-center gap-4">
                <div className="w-12 h-px bg-gold-400/30"></div>
                <div className="text-gold-400/80 text-lg">✟</div>
                <div className="w-12 h-px bg-gold-400/30"></div>
              </div>
            </div>
            
            <RegisterForm />
            
            <div className="text-center">
              <p className="text-sm text-burgundy-600">
                Already have an account?{' '}
                <Link
                  to="/login"
                  className="font-medium text-burgundy-700 hover:text-burgundy-800 transition-colors duration-300"
                >
                  Sign in here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register; 